import LayerMappingsEnum from "../enums/LayerMappingsEnum";
import { Layers } from "three";
import { ElementTypeEnum } from "../elementTypeMappings";
import ShapeTypeEnum from "../model/representation2d/ShapeTypeEnum";
import Representation3dTypeEnum from "../model/representation3d/Representation3dTypeEnum";
import Product from "../model/Product";
import CoveringData from "../model/productData/CoveringData"
import IfcCoveringTypeEnum from "../enums/IfcCoveringTypeEnum";
import { sceneUnitsFromMm } from "./scaler";
import ProductData from "../model/productData/ProductData";

export const getLayerNames = (layers: Layers) => {

    const layerNames : string[] = [];

    const tempLayers = new Layers();
    for (let i = 0; i < 32; i++) {
        tempLayers.disableAll();
        tempLayers.set(i);
        if (layers.test(tempLayers)) {
            layerNames.push(LayerMappingsEnum[i] ?? `Layer ${i}`);
        }
    }

    return layerNames;
}

const getLayerTypeForFillingRepresentation2d = (elementType: ElementTypeEnum, shapeType: ShapeTypeEnum) => {
    switch (shapeType) {
        case ShapeTypeEnum.Lineloops:
            return elementType === ElementTypeEnum.Door ? LayerMappingsEnum.DoorSymbols : LayerMappingsEnum.WindowSymbols;
        case ShapeTypeEnum.Shape:
            return LayerMappingsEnum.FillingShapes;
        default:
            return LayerMappingsEnum.Elements2d;
       }
};

export const getLayerForProductRepresentation2d = ( elementType: ElementTypeEnum, 
                                                    representationType2d: ShapeTypeEnum, 
                                                    productData: ProductData) : LayerMappingsEnum => {
    
    switch (elementType) {

        case ElementTypeEnum.Wall:
            return LayerMappingsEnum.Elements2d;
        
        case ElementTypeEnum.Fixture:
            return LayerMappingsEnum.Fixtures2d;
                
        case ElementTypeEnum.Covering:
            const coveringData = productData as CoveringData;
            switch (coveringData.coveringType)
            {
                case IfcCoveringTypeEnum.FLOORING:
                    return LayerMappingsEnum.FloorCoverings2d;
                case IfcCoveringTypeEnum.CLADDING:
                    return LayerMappingsEnum.WallCoverings2d;
                case IfcCoveringTypeEnum.CEILING:
                    return LayerMappingsEnum.CeilingCoverings2d;
                case IfcCoveringTypeEnum.USERDEFINED:
                    return coveringData.isSkirting 
                        ? LayerMappingsEnum.Skirtings2d 
                        : LayerMappingsEnum.Hidden;
                default:
                    return LayerMappingsEnum.Hidden;
            }
                
        case ElementTypeEnum.Door:
        case ElementTypeEnum.Window:
            return getLayerTypeForFillingRepresentation2d(elementType, representationType2d);

        case ElementTypeEnum.Space:
            return LayerMappingsEnum.Spaces2d;

        case ElementTypeEnum.Storey:
            return LayerMappingsEnum.StoreyNames2d;

        default:
            console.warn(`Layer for product type ${elementType} and representation type ${representationType2d} not defined.`);
            return LayerMappingsEnum.Default;
            
    }
    
};

export const getLayerForProductRepresentation3d = ( elementType: ElementTypeEnum, 
                                                    representationType: Representation3dTypeEnum,
                                                    productData: ProductData) : LayerMappingsEnum => {
    
    switch (elementType) {

        case ElementTypeEnum.Wall:
            return LayerMappingsEnum.Elements3d;
        
        case ElementTypeEnum.Covering:
            const coveringData = productData as CoveringData;
            switch (coveringData.coveringType)
            {
                case IfcCoveringTypeEnum.CEILING:
                    return LayerMappingsEnum.CeilingCoverings3d;
                case IfcCoveringTypeEnum.FLOORING:
                    return LayerMappingsEnum.FloorCoverings3d;
                case IfcCoveringTypeEnum.CLADDING:
                    return LayerMappingsEnum.WallCoverings3d;
                case IfcCoveringTypeEnum.USERDEFINED:
                    return coveringData.isSkirting 
                        ? LayerMappingsEnum.Skirtings3d 
                        : LayerMappingsEnum.Hidden;

                default:
                    return LayerMappingsEnum.Hidden;
            }

        case ElementTypeEnum.Door:
        case ElementTypeEnum.Window:
            return LayerMappingsEnum.Elements3d;
            
        case ElementTypeEnum.Space: // 3D representation for space is not used
            return LayerMappingsEnum.Hidden;

        case ElementTypeEnum.Fixture:
            return LayerMappingsEnum.Fixtures3d;

        default:
            console.warn(`Layer for product type ${elementType} and representation type ${representationType} not defined.`);
            return LayerMappingsEnum.Default;
    }
};

export const getHeightOffsetByLayer2d = (layer: LayerMappingsEnum) => { 

    switch (layer)
    {
        
        case LayerMappingsEnum.Spaces2d:
            return sceneUnitsFromMm(5);
        
        case LayerMappingsEnum.FloorCoverings2d:
        case LayerMappingsEnum.FloorCoverings3d:
            return sceneUnitsFromMm(6);

        case LayerMappingsEnum.DoorSymbols:
        case LayerMappingsEnum.WindowSymbols:
        case LayerMappingsEnum.FillingShapes:
        case LayerMappingsEnum.Skirtings2d:
            return sceneUnitsFromMm(7);

        case LayerMappingsEnum.Fixtures2d:
            return sceneUnitsFromMm(8);
        case LayerMappingsEnum.Elements2d:
        case LayerMappingsEnum.WallCoverings2d:
            return sceneUnitsFromMm(9);

        case LayerMappingsEnum.Hidden:
            return 0.0;

        default:
            console.error("Calling getHeightOffsetByLayer2d with unknown layer");
            return 0.0;
    }

}

            